import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, formatError } from "@/lib/api";
import { localToday } from "@/lib/dates";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const EMPTY = { name: "", subject: "", date: "", topics: "" };

export function ExamDialog({ exam, onClose, onSaved }) {
  const [f, setF] = useState(exam ? { ...exam, topics: exam.topics.join(", ") } : EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = { name: f.name, subject: f.subject, date: f.date, topics: f.topics.split(/[,\n]/).map((t) => t.trim()).filter(Boolean) };
    try {
      const { data } = exam ? await http.put(`/exams/${exam.exam_id}`, body) : await http.post("/exams", body);
      toast.success(exam ? "Exam updated" : "Exam added");
      onSaved(data);
    } catch (err) { toast.error(formatError(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-[#0E121C] border-white/10 max-w-md" data-testid="exam-dialog">
        <DialogHeader><DialogTitle className="font-display">{exam ? "Edit exam" : "Add an exam"}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <Input required value={f.name} onChange={set("name")} placeholder="Exam name, e.g. Biology final" className="bg-white/5 border-white/10 h-11" data-testid="exam-name-input" />
          <Input value={f.subject} onChange={set("subject")} placeholder="Subject, e.g. Biology" className="bg-white/5 border-white/10 h-11" data-testid="exam-subject-input" />
          <Input required type="date" min={exam ? undefined : localToday()} value={f.date} onChange={set("date")} className="bg-white/5 border-white/10 h-11" data-testid="exam-date-input" />
          <textarea value={f.topics} onChange={set("topics")} rows={3} placeholder="Topics it covers, separated by commas"
            className="w-full rounded-md bg-white/5 border border-white/10 px-3 py-2 text-base sm:text-sm outline-none focus:border-sky-400/50" data-testid="exam-topics-input" />
          <button type="submit" disabled={busy} className="w-full h-11 rounded-full bg-sky-400 text-white font-medium hover:bg-sky-500 disabled:opacity-50" data-testid="exam-save-btn">
            {busy ? <Loader2 className="h-4 w-4 animate-spin mx-auto" /> : exam ? "Save changes" : "Add exam"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
